<template>
    <div>
        <el-breadcrumb class="Breadcrumb" separator="/">
            <el-breadcrumb-item>角色管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>
        <div class="search">
            <el-row :gutter="24">
                <el-col :span="4" :offset="0">
                    <el-input v-model="search.name" placeholder="请输入角色名称"></el-input>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="getListFun(1)" icon="el-icon-search">查询</el-button>
                    <el-button type="primary" @click="openAdd()" icon="el-icon-plus">添加</el-button>
                </el-col>
            </el-row>
        </div>
        <el-divider></el-divider>
        <div class="table">
            <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column type="index" label="序号" width="200">
                </el-table-column>
                <el-table-column prop="name" label="角色名称">
                </el-table-column>
                <el-table-column prop="createdDate" label="创建时间">
                </el-table-column>
                <el-table-column prop="id" fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button @click="openEdit(scope.row.id)" type="text" icon="el-icon-edit"
                            :disabled="scope.row.id==1" size="small">编辑</el-button>
                        <el-button @click="deleteFun(scope.row.id)" type="text" icon="el-icon-delete"
                            :disabled="scope.row.id==1" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--分页-->
        <div class="pagination">
            <el-pagination background @size-change="changSizeFun" @current-change="changpageFun"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum">
            </el-pagination>
        </div>


        <!-- 弹窗-->
        <el-dialog :title="popTitle" :visible.sync="pop" @close="resetForm('ruleForm')" width="25%">
            <el-form :model="formDate" :rules="rules" ref="ruleForm" label-width="80px">
                <el-form-item label="角色名称" prop="name">
                    <el-input placeholder="请输入角色名称" v-model="formDate.name"></el-input>
                </el-form-item>
                <el-tree ref="tree" :props="defaultProps" :data="allMenu" show-checkbox :default-checked-keys="formDate.menuId" node-key="id"
                    :default-expand-all="true">
                </el-tree>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('ruleForm')">取 消</el-button>
                <el-button type="primary" @click="subFun('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    data() {
        return {
            pageSize: 10,
            pageNum: 1,
            totalNum: 0,
            search: {
                name: ""
            },
            //table数据
            tableData: [],
            formDate: {
                id: "",
                name: "",
                menuId: [],
            },
            //弹窗
            pop: false,
            popTitle: "",
            allMenu: "",
            //修改菜单项默认结构
            defaultProps: {
                children: 'children',
                label: 'name',
            },
            rules: {
                name: [
                    { required: true, message: '请输入角色名称', trigger: 'blur' },
                    { min: 3, max: 12, message: '长度在 3 到 12 个字符', trigger: 'blur' }
                ]
            }
        };
    },
    mounted() {
        this.getList();
        this.getAllMenu();
    },
    methods: {
        //查询列表
        getList() {
            let data = {
                name: this.search.name,
                pageSize: this.pageSize,
                pageNum: this.pageNum,
            }
            this.$get(api + "/roles/getList", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.tableData = res.data;
                    this.totalNum = res.totalNum
                }
            })
        },
        //获取全部菜单
        getAllMenu() {
            let data = {}
            this.$get(api + "/roles/getAllMenu", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.allMenu = res.data;
                    this.allMenu.forEach(item =>{
                        if(item.id==1){
                            item.disabled = true
                        }
                    })
                }
            })
        },

        //打开添加弹窗
        openAdd() {
            this.formDate = {
                id: '',
                name: '',
                menuId: [1],
            };
            this.popTitle = '添加角色';
            this.pop = true;
            this.$nextTick(() => {
                this.$refs.tree.setCheckedKeys(this.formDate.menuId, false);
            })
        },
        //打开编辑弹窗
        openEdit(id) {
            let data = {}
            this.$get(api + "/roles/getInfo/" + id, data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.formDate.id = id;
                    this.formDate.name = res.data.name;
                    this.formDate.menuId = res.data.menuIds;
                    this.popTitle = '编辑角色';
                    this.pop = true;
                    this.$nextTick(() => {
                        this.$refs.tree.setCheckedKeys(this.formDate.menuId, false);
                    })
                }
            })
        },

        //添加角色
        addRoleFun() {
            let data = {
                name: this.formDate.name,
                menuId: this.formDate.menuId,
            }
            this.$post(api + "/roles/addRole", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '添加成功!'
                    })
                    this.pop = false;
                    this.getListFun(1);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },
        //修改角色
        editRoleFun() {
            let data = {
                id: this.formDate.id,
                name: this.formDate.name,
                menuId: this.formDate.menuId,
            }
            this.$post(api + "/roles/editRole", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    });
                    this.pop = false;
                    this.getListFun(this.pageNum);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },

        //删除角色
        deleteFun(row) {
            this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {}
                this.$post(api + "/roles/delete/" + row, data).then(response => {
                    let res = response.data;
                    if (res.code == 0) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getListFun(1);
                    } else {
                        this.$message.error(res.desc);
                    }
                })
            }).catch(() => {

            });
        },

        //弹窗确定
        subFun(formName) {
            let arr1 = this.$refs.tree.getCheckedKeys()
            let arr2 = this.$refs.tree.getHalfCheckedKeys()
            this.formDate.menuId = [...arr2, ...arr1]
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!this.formDate.id) {
                        this.addRoleFun();
                    } else {
                        this.editRoleFun();
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            console.log(this.formDate.id);
        },
        //关闭弹窗
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.pop = false;
        },
        //特定pageNum查询列表
        getListFun(val) {
            this.pageNum = val;
            this.getList();
        },

        //更换pageSize
        changSizeFun(val) {
            console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.getList();
        },
        //翻页
        changpageFun(val) {
            console.log(this.pageNum);
            this.pageNum = val;
            this.getList();
        },

    }
}
</script>

<style>
.Breadcrumb {
    _box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}


.el-row {
    margin-bottom: 20px;
}

.el-col {
    border-radius: 0px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.grid-content {
    border-radius: 0px;
    min-height: 36px;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
</style>


// WEBPACK FOOTER //
// src/pages/sysset/role/Role.vue